package com.daytimegaming.ourdailyfinances.domain.model

data class Counterparty(
    val name: String,
    val type: String,
    val website: String?,
    val logoUrl: String?,
    val entityId: String?,
    val confidenceLevel: String?,
)

data class Location(
    val address: String?,
    val city: String?,
    val region: String?,
    val postalCode: String?,
    val country: String?,
    val lat: Double?,
    val lon: Double?,
    val storeNumber: String?,
)

data class PaymentMeta(
    val referenceNumber: String?,
    val ppdId: String?,
    val payee: String?,
    val byOrderOf: String?,
    val payer: String?,
    val paymentMethod: String?,
    val paymentProcessor: String?,
    val reason: String?,
)

data class PersonalFinanceCategory(
    val primary: String,
    val detailed: String,
    val confidenceLevel: String?,
    val version: String?,
)

data class Transaction(
    val transactionId: String,
    val accountId: String,
    val amount: Double,
    val date: String,
    val name: String,
    val merchantName: String?,
    val category: List<String>,
    val pending: Boolean,
    val isoCurrencyCode: String?,
    val logoUrl: String? = null,
    val website: String? = null,
    val personalFinanceCategoryIconUrl: String? = null,
    val counterparties: List<Counterparty>? = null,
    val location: Location? = null,
    val paymentMeta: PaymentMeta? = null,
    val personalFinanceCategory: PersonalFinanceCategory? = null,
    val userCategoryOverride: PersonalFinanceCategory? = null,
) {
    val activeCategory: PersonalFinanceCategory?
        get() = userCategoryOverride ?: personalFinanceCategory
}
